import { RefObject, useLayoutEffect, useRef } from 'react'
import { useControlStore } from '@editorStores'

const useRegisterSnackbarAnchor = <T extends HTMLElement>(): RefObject<T | null> => {
  const registerSnackbarAnchor = useControlStore(state => state.registerSnackbarAnchor)
  const anchorRef = useRef<T | null>(null)

  useLayoutEffect(() => {
    registerSnackbarAnchor(anchorRef.current)
    return () => registerSnackbarAnchor(null)
  }, [registerSnackbarAnchor])

  return anchorRef
}

export default useRegisterSnackbarAnchor
